import { ROLLOUTS_PATH } from 'distributions/navigation';

module.exports = {
  path: ROLLOUTS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DistributionRollouts'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/routes/show/routes/rollouts/index.js